import React, { useState, useRef } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import callapi from '../../helpers/callapi'
import RefundOrder from './RefundOrder'

export default function Refunds() {
  const previewRef = useRef(null)
  const fileRef = useRef(null)
  const transRef = useRef(null)
  const amountRef = useRef(null)
  const senderRef = useRef(null)
  const [transNo, setTransNo] = useState('')
  const [isEnableBtnSave, setIsEnableBtnSave] = useState(false)
  const [isBrowseFile, setIsBrowseFile] = useState(true)
  const [order, setOrder] = useState(null)
  const [slip, setSlip] = useState(null)
  function base64(file, cb) {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      const base64data = reader.result
      const strBase64 = base64data.substr(base64data.indexOf(',') + 1)
      const imageBase64 = strBase64
      cb(imageBase64)
    }
    reader.onerror = function (error) {
      console.log('Error: ', error)
    }
  }
  function clearForm() {
    setTransNo('')
    setIsEnableBtnSave(false)
    setIsBrowseFile(true)
    setSlip(null)
    fileRef.current.value = ''
    if (previewRef.current.hasChildNodes()) {
      previewRef.current.removeChild(previewRef.current.childNodes[0])
    }
    if (transRef && transRef.current) transRef.current.value = ''
    if (amountRef && amountRef.current) amountRef.current.value = ''
    if (senderRef && senderRef.current) senderRef.current.value = ''
  }
  function handleOnChangeFile(e) {
    const [file] = e.target.files
    if (file) {
      const elPreviewImage = document.createElement('img')
      elPreviewImage.src = URL.createObjectURL(file)
      elPreviewImage.style.width = '100%'
      elPreviewImage.style.height = '100%'
      if (previewRef.current.hasChildNodes()) {
        previewRef.current.replaceChild(elPreviewImage, previewRef.current.childNodes[0])
      } else {
        previewRef.current.appendChild(elPreviewImage)
      }
      setTransNo('')
    }
  }
  function handleOnSave() {
    try {
      if (senderRef && senderRef.current && senderRef.current.value === '') {
        senderRef.current.focus()
        console.log(senderRef.current)
        alert('กรุณาระบุชื่อผู้ฝาก')
        return
      }
      const body = {
        transRef: transNo,
        receiver: slip && slip.receiver ? slip.receiver : 'บจก. ลอตเตอรี่ออนไลน์',
        sender: slip && slip.sender ? slip.sender : senderRef ? senderRef.current.value : null,
        amount: slip && slip.amount ? slip.amount : amountRef ? amountRef.current.value : null,
      }
      callapi({ url: '/orders/refund', method: 'post', body })
        .then((res) => {
          if (res.status === 'success') {
            clearForm()
            alert('บันทึกเรียบร้อย')
          } else {
            console.log(res)
            alert(res.message ? res.message : 'เกิดข้อผิดพลาด')
          }
        })
        .catch((err) => {
          console.log(err)
          alert(err.message)
        })
    } catch (err) {
      transRef.current.focus()
      alert(err.message)
    }
  }
  function handleOnVerifiedSlipManual() {
    const transRefNo = transRef.current.value
    if (!transRefNo) {
      alert('กรุณากรอกหมายเลขสลิปธนาคาร')
      return
    }
    callapi({ url: `/orders/verifiedslip/${transRefNo}` })
      .then((res) => {
        if (res.status === 'success') {
          responseSuccessFlow(res)
          if (!res.refund) {
            setTransNo(transRefNo)
            amountRef && amountRef.current.focus()
          }
        } else {
          setIsEnableBtnSave(true)
          transRef.current.focus()
          alert('ไม่สามารถตรวจสอบได้ กรุณากรอกรหัสอ้างอิงอีกครั้ง')
          return
        }
      })
      .catch((err) => {
        console.log(err)
        transRef.current.focus()
        alert(err.message)
      })
  }
  function handleOnVerifiedSlip() {
    const [file] = fileRef.current.files
    if (file) {
      base64(file, (base64Image) => {
        callapi({ url: '/orders/verifiedslip', method: 'post', body: { base64Image } })
          .then((res) => {
            //console.log(res);
            if (res.status === 'success') {
              responseSuccessFlow(res)
            } else {
              setIsEnableBtnSave(false)
              setIsBrowseFile(false)
              setSlip(null)
              setOrder(null)
              transRef.current.focus()
              alert(res.message ? res.message : 'เกิดข้อผิดพลาด')
            }
          })
          .catch((err) => {
            setIsEnableBtnSave(false)
            console.log(err)
            alert(err.message)
          })
      })
    } else {
      setIsBrowseFile(true)
      setIsEnableBtnSave(false)
      alert('กรุณาเลือกไฟล์สลิปที่ต้องการบันทึก')
    }
  }
  function handleOnCancel() {
    clearForm()
  }
  function responseSuccessFlow(res) {
    if (res.order || res.refund) {
      setIsEnableBtnSave(false)
    } else {
      setIsEnableBtnSave(true)
    }
    if (res.refund) {
      if (fileRef && fileRef.current) fileRef.current.value = ''
      if (previewRef.current.hasChildNodes()) {
        previewRef.current.removeChild(previewRef.current.childNodes[0])
      }
      clearForm()
      alert('มีอยู่ในระบบเรียบร้อยแล้วคะ')
      return
    } else {
      if (res.order) {
        setOrder(res.order)
      } else {
        setOrder(null)
      }
      if (res.data) {
        //console.log(res.data);
        setSlip(res.data)
        setTransNo(res.data.transRef)
      } else {
        setSlip(null)
      }
    }
  }
  return (
    <>
      <Card>
        <Card.Header>Refund</Card.Header>
        <Card.Body>
          <Row>
            <Col>
              <div className="d-flex">
                <div className="d-flex flex-column">
                  <div>
                    <div className="d-flex justify-content-center">
                      <div className="d-flex pb-5" style={{ width: '400px' }}>
                        <div
                          className="d-flex"
                          ref={previewRef}
                          style={{ height: '560px', maxHeight: '560px', maxWidth: '400px' }}
                        ></div>
                      </div>
                    </div>
                    {isBrowseFile ? (
                      <div>
                        <div className="d-flex">
                          <div className="d-flex input-group">
                            <input className="form-control" type="file" ref={fileRef} onChange={handleOnChangeFile} />
                          </div>
                        </div>
                        <div className="d-flex pt-2 pb-2">
                          <div style={{ width: '100%' }}>
                            <button
                              className="btn btn-outline-primary"
                              style={{ width: '100%' }}
                              onClick={handleOnVerifiedSlip}
                            >
                              ตรวจสอบสลิป
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex">
                          <div className="d-flex input-group">
                            <input
                              type="text"
                              ref={transRef}
                              placeholder="รหัสอ้างอิง"
                              className="form-control"
                              autoFocus
                            />
                          </div>
                        </div>
                        <div className="d-flex pt-2 pb-2">
                          <div style={{ width: '100%' }}>
                            <button
                              className="btn btn-outline-primary"
                              style={{ width: '100%' }}
                              onClick={handleOnVerifiedSlipManual}
                            >
                              ตรวจสอบ
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* <div className='d-flex'>
                      <div className='btn' onClick={()=>setIsBrowseFile(true)}>แนบไฟล์</div>
                      <div className='btn' onClick={()=>setIsBrowseFile(false)}>กรอกเลขบัญชี</div>
                    </div> */}
                  </div>
                </div>
                <div className="d-flex flex-column pl-5" style={{ width: '100%' }}>
                  <div className="d-flex flex-column" style={{ minHeight: '672px' }}>
                    <div className="d-flex flex-column mb-5">
                      <div className="d-flex justify-content-between">
                        <div className="pt-2 pb-2">รหัสอ้างอิง: {slip && slip.transRef ? slip.transRef : transNo}</div>
                        <div className="pt-2 pb-2">
                          จำนวนเงิน{' '}
                          {slip && slip.amount ? (
                            slip.amount
                          ) : (
                            <input
                              type="number"
                              className="ml-1 mr-1"
                              placeholder={0}
                              style={{
                                textAlign: 'right',
                                padding: '0px',
                                border: 'none',
                                borderBottom: '1px solid #7E7E7E',
                              }}
                              ref={amountRef}
                            />
                          )}{' '}
                          บาท
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="pt-2 pb-2">
                          จาก{' '}
                          {slip && slip.sender ? (
                            slip.sender
                          ) : (
                            <input
                              type="text"
                              className="ml-1"
                              placeholder="ระบุชื่อผู้ฝาก"
                              style={{ padding: '0px 4px', border: 'none', borderBottom: '1px solid #7E7E7E' }}
                              ref={senderRef}
                            />
                          )}
                        </div>
                        <div className="pt-2 pb-2">
                          ไปยัง {slip && slip.receiver ? slip.receiver : 'บจก. ลอตเตอรี่ออนไลน์'}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="pt-2 pb-2">รายการคำสั่งซื้อ</div>
                      <RefundOrder order={order} />
                    </div>
                  </div>
                  <div className="d-flex pl-4 pr-4" style={{ width: '100%' }}>
                    <div className="d-flex mr-5">
                      <button className="btn pl-5 pr-5 " onClick={handleOnCancel}>
                        ยกเลิก
                      </button>
                    </div>
                    <div className="d-flex w-100">
                      <button
                        className="d-flex btn btn-primary justify-content-center"
                        style={{
                          width: '100%',
                          backgroundColor: !isEnableBtnSave ? '#9E9E9E' : '',
                          borderColor: !isEnableBtnSave ? '#9E9E9E' : '',
                        }}
                        disabled={!isEnableBtnSave}
                        onClick={handleOnSave}
                      >
                        บันทึก
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  )
}
